import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isCountriesTax } from 'countriesTax';
import { Icon } from 'semantic-ui-react';
import Carrousel from 'components/atoms/Carrousel/Carrousel';
import { Language } from 'language/Language';
import InlineSpinner from 'components/atoms/Spinner/InlineSpinner';
import { Button } from 'components/atoms/Button';
import { api } from 'api';
import { ProductHeroButton } from './ProductHeroButton';
import { strings } from './strings';
import ProductImage from '../image/ProductImage';
import CarrouselFull from '../carrouselFull/CarrouselFull';
import { images } from '../images';
import './_ProductHero.scss';

const ProductHero = () => {
  // this is because wordpress changes the value
  if (process.env.REACT_APP_PADDLE_ENVIRONMENT === 'sandbox') {
    window.Paddle.Environment.set('sandbox');
  }

  const {
    siteInfo: { priceProduct, countryUser, subscription },
    entitlement,
    subscription: userSubscription,
    fetchStatus,
  } = useSelector((state) => state);
  const { userInfo } = useSelector((state) => state);
  const [pos, setPos] = useState(0);
  const [full, setFull] = useState(false);
  const [loadingPauseAction, setLoadingPauseAction] = useState(false);
  const language = Language();
  const isJapanese = countryUser === 'JP';

  const advanceImage = () => {
    if (pos !== images.length - 1) {
      setPos(pos + 1);
    } else {
      setPos(0);
    }
  };

  const backImage = () => {
    if (pos !== 0) {
      setPos(pos - 1);
    } else {
      setPos(images.length - 1);
    }
  };

  const priceText = subscription?.prices?.gross ? ` - ${subscription.prices.gross} / mo` : '';
  const hasNoSub = !userSubscription || (userSubscription.status === 'Cancelled' && new Date(userSubscription.nextRenewal).valueOf() < new Date().valueOf());
  const hasPausedSub = userSubscription && userSubscription.pausedFrom;

  const showSubBtn = !isJapanese && hasNoSub && fetchStatus !== 'loading';
  const showResumeBtn = !isJapanese && hasPausedSub;
  const showSubProductLink = !isJapanese && fetchStatus === 'complete' && !hasNoSub && !hasPausedSub;

  async function resumeSub() {
    setLoadingPauseAction(true);
    try {
      await api.resumeSub();
    } catch (e) {
      console.error(e);
    }
    setLoadingPauseAction(false);
  }

  return (
    <div className='product'>
      {!full
        ? (
          <>
            <div className='product-container'>
              <div className='product-item'>
                <figure>
                  <ProductImage
                    advanceImage={advanceImage}
                    backImage={backImage}
                    currentImage={images[pos]}
                    imageStyle='product-hero__img'
                  />
                  <div className='product-img__full'>
                    <Icon
                      size='large'
                      name='expand'
                      onClick={() => setFull(true)}
                    />
                  </div>
                </figure>
              </div>
              <div className='product-item product-item__left'>
                <h1>WalkMix® Creator</h1>
                <p className='product-item__description'>{strings[language].description}</p>
                {
                  showSubBtn && (
                    <>
                      <a className='main-btn product-subscribe' href={userInfo ? '/checkout?type=subscription' : '/my-account?redirectTo=checkout?type=subscription'} target='_blank' rel='noreferrer'>
                        {strings.english.subscribe}
                        {priceText}
                        {!priceText && <span style={{ marginLeft: '10px' }}><InlineSpinner /></span>}
                      </a>
                    </>
                  )
                }

                {
                  showResumeBtn && (
                    <Button disabled={loadingPauseAction} onClick={resumeSub} text={loadingPauseAction ? <InlineSpinner /> : 'Resume'} />
                  )
                }

                {
                  showSubProductLink && (
                    <>
                      <p style={{ marginTop: 30 }}>
                        Welcome to WalkMix Creator! You can now download the product from the link below.
                      </p>
                      <Link className='main-btn product-subscribe' to='/my-account/products'>
                        My Products
                      </Link>
                    </>
                  )
                }

                {
                  Boolean(showSubBtn || showResumeBtn || showSubProductLink) && (
                    <p className='product-separator-text'>{strings.english.or}</p>
                  )
                }

                <ProductHeroButton
                  isJapanese={isJapanese}
                  language={language}
                  userInfo={userInfo}
                />
                {(priceProduct && !isCountriesTax(countryUser)) && <p className='product-tax'>{isJapanese ? strings[language].redirect : !entitlement && (strings[language].tax)}</p>}
              </div>
            </div>
            <Carrousel
              images={images}
              changeImage={setPos}
              pos={pos}
              setFull={setFull}
            />
          </>
        )
        : (
          <CarrouselFull
            advanceImage={advanceImage}
            backImage={backImage}
            currentImage={images[pos]}
            pos={pos}
            setFull={setFull}
          />
        )}
    </div>
  );
};

export default ProductHero;
